wbApp.controller('AccountingBookDetailCtrl', ['$scope', 'accountingBookSvc', '$timeout', '$modal', 'messageBoxSvc', '$routeParams', '$translate', '$location',
function ($scope, accountingBookSvc, $timeout, $modal, messageBoxSvc, $routeParams, $translate, $location) {

    $scope.modelOrig = angular.copy($scope.model);
    $scope.isBussy = false;

    $scope.bankImportCredentials = {
        shopName: null,
        password: null
    };

    $scope.minFromDate = moment().subtract(90, 'days').toDate();
    $scope.goCardlessData = {
        id: $scope.model.bankTransactionImportType === 3 ? $scope.model.securityAccessToken : null,
        institutionId: null,
        statusStr: null
    }
    
    $scope.accountingStampUrl = `restapi/accounting-books/${$scope.model.id}/accounting-stamp`;

    if ($scope.model.securityAccessToken && $scope.model.bankTransactionImportType == 2) {
        var split = $scope.model.securityAccessToken.split('#');
        if (split.length == 2) {
            $scope.bankImportCredentials.shopName = split[0];
            $scope.bankImportCredentials.password = split[1];
        }
    }

    // 0 - TXT_VAL_BANK_CONNECTION_STATUS_CREATED
    // 1 - TXT_VAL_BANK_CONNECTION_STATUS_GIVING_CONSENT
    // 2 - TXT_VAL_BANK_CONNECTION_STATUS_UNDERGOING_AUTHENTICATION
    // 3 - TXT_VAL_BANK_CONNECTION_STATUS_REJECTED
    // 4 - TXT_VAL_BANK_CONNECTION_STATUS_SELECTING_ACCOUNTS
    // 5 - TXT_VAL_BANK_CONNECTION_STATUS_GRANTING_ACCESS
    // 6 - TXT_VAL_BANK_CONNECTION_STATUS_LINKED
    // 7 - TXT_VAL_BANK_CONNECTION_STATUS_EXPIRED
    // 8 - TXT_VAL_BANK_CONNECTION_STATUS_UNKNOWN
    
    if ($scope.model.bankTransactionImportType === 3) {
        accountingBookSvc.getConnection($scope.model.securityAccessToken).$promise.then(function (data) {
            $scope.goCardlessData = angular.extend({}, data, $scope.goCardlessData);
            switch(data.status) {
                case 0:
                    $scope.goCardlessData.statusStr = $translate.instant('TXT_VAL_BANK_CONNECTION_STATUS_CREATED');
                    break;
                case 1:
                    $scope.goCardlessData.statusStr = $translate.instant('TXT_VAL_BANK_CONNECTION_STATUS_GIVING_CONSENT');
                    break;
                case 2:
                    $scope.goCardlessData.statusStr = $translate.instant('TXT_VAL_BANK_CONNECTION_STATUS_UNDERGOING_AUTHENTICATION');
                    break;
                case 3:
                    $scope.goCardlessData.statusStr = $translate.instant('TXT_VAL_BANK_CONNECTION_STATUS_REJECTED');
                    break;
                case 4:
                    $scope.goCardlessData.statusStr = $translate.instant('TXT_VAL_BANK_CONNECTION_STATUS_SELECTING_ACCOUNTS');
                    break;
                case 5:
                    $scope.goCardlessData.statusStr = $translate.instant('TXT_VAL_BANK_CONNECTION_STATUS_GRANTING_ACCESS');
                    break;
                case 6:
                    $scope.goCardlessData.statusStr = $translate.instant('TXT_VAL_BANK_CONNECTION_STATUS_LINKED');
                    break;
                case 7:
                    $scope.goCardlessData.statusStr = $translate.instant('TXT_VAL_BANK_CONNECTION_STATUS_EXPIRED');
                    break;
                case 8:
                    $scope.goCardlessData.statusStr = $translate.instant('TXT_VAL_BANK_CONNECTION_STATUS_UNKNOWN');
                    break;
            }
        });
    }

    $scope.onBankImportCredentialsChange = function (shopName, password) {
        if ($scope.model.bankTransactionImportType == 2) {
            $scope.model.securityAccessToken = shopName + '#' + password;
        }
    }

    $scope.onImportTypeChange = function (val) {
        $scope.model.securityAccessToken = null;
        $scope.bankImportCredentials.shopName = null;
        $scope.bankImportCredentials.password = null;

        if ($scope.model.bankTransactionImportType == 0) {
            $scope.model.bankTransactionImportAmountLimit = null;
            $scope.model.bankTransactionImportStartDate = null;
        }
    }
    
    $scope.onSelectBankClick = function () {
        bankSelectionDialogPromise.$promise.then(function () {
            bankSelectionDialogPromise.$scope.model = $scope.model;
            bankSelectionDialogPromise.$scope.onInstitutionSelected = function (institution) {
                $scope.isBussy = true;
                accountingBookSvc.createBankConnection(
                    institution.id,
                    `${location.href}/${$scope.model.id}/tab/bank`,
                    $scope.model.id).$promise.then(function (data) {
                        $scope.model.securityAccessToken = data.id;
                        accountingBookSvc.update($scope.model, function () {
                            $scope.isBussy = false;
                            window.location.href = data.authorizationLinkUrl;
                        }, 
                        function(error) {
                            $scope.isBussy = false;
                        });
                }, function (error) {$scope.isBussy = false});
            }
            bankSelectionDialogPromise.show();
        });
    }
    
    $scope.onSelectBankAccount = function () {
        bankAccountSelectionDialogPromise.$promise.then(function () {
            bankAccountSelectionDialogPromise.$scope.model = $scope.goCardlessData;
            bankAccountSelectionDialogPromise.$scope.onBankAccountSelected = function (account) {
                $scope.isBussy = true;
                accountingBookSvc.selectBankAccount($scope.goCardlessData.id, account.id).$promise.then(function (data) {
                    $scope.goCardlessData.selectedAccountIndex = data.selectedAccountIndex;
                    $scope.isBussy = false;
                },
                function (reason) {
                    $scope.isBussy = false;
                });
            }
            bankAccountSelectionDialogPromise.show();
        });
    }
    
    $scope.onDeleteBankConnection = function () {
        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_DELETE_BANK_CONNECTION',
            message: 'TXT_TEXT_CONFIRM_DELETE_BANK_CONNECTION',
            buttons: [{
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: function () {
                    $scope.isBussy = true;
                    accountingBookSvc.deleteConnection($scope.model.securityAccessToken).$promise.then(function () {
                        $scope.model.securityAccessToken = null;
                        $scope.model.bankTransactionImportType = 0;
                        accountingBookSvc.update($scope.model, function () {
                            $scope.isBussy = false;
                            $scope.goCardlessData = {
                                id: null,
                                institutionId: null,
                                statusStr: null
                            };
                        }, function (error) {
                            $scope.isBussy = false;
                        });
                    }, function (error) {
                        $scope.isBussy = false;
                    });
                }
            }]
        });
    }

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "finance/accounting-books/accounting-books-detail-main-tab.html",
            tabId: 'main'
        },
        {
            title: "TXT_LBL_ACCOUNTING",
            template: "finance/accounting-books/accounting-books-detail-accounting-tab.html",
            tabId: 'accounting'
        },
        {
            title: "TXT_LBL_BANK",
            template: "finance/accounting-books/accounting-books-detail-bank-tab.html",
            tabId: 'bank'
        }
    ];

    if (!!$scope.model.id) {
        $scope.detailTabs.push({
            title: "TXT_LBL_SEQUENCES",
            template: "finance/accounting-books/accounting-books-detail-sequences-tab.html",
            tabId: 'sequences'
        });
        $scope.detailTabs.push({
            title: "TXT_LBL_ACCOUNTING_STAMP",
            template: "finance/accounting-books/accounting-books-detail-accounting-stamp-tab.html",
            tabId: 'accounting-stamp'
        });
    }

    $scope.detailTabs.activeTab = 0;

    let selectedTabId = $routeParams.tabId;
    if (selectedTabId) {
        let selectedTabIndex = _.findIndex($scope.detailTabs, { tabId: selectedTabId });
        if (selectedTabIndex !== -1) {
            $scope.detailTabs.activeTab = selectedTabIndex;    
        }
    }
    
    $scope.isTdSequenceSaving = false;
    $scope.tdSeq = {
        selectedYear: moment().year(),
        accountingBookId: $scope.model.id,
        nextSequenceNo: 1
    };
       
    if (!!$scope.model.id) {
        accountingBookSvc.peekNextSequenceNoRaw(
            3, /* TaxDocument */
            $scope.tdSeq.accountingBookId,
            $scope.tdSeq.selectedYear, function (data) {
                $scope.tdSeq.nextSequenceNo = data.value;
            });
    }

    $scope.onTaxDocumentYearChange = function (year) {
        accountingBookSvc.peekNextSequenceNoRaw(3, $scope.tdSeq.accountingBookId, $scope.tdSeq.selectedYear, function (nextSeq) {
            $scope.tdSeq.nextSequenceNo = nextSeq.value;
        });
    }

    $scope.onTaxDocumentSequnceSave = function (m) {
        if ($scope.isTdSequenceSaving) {
            return;
        }

        $scope.isTdSequenceSaving = true;
        accountingBookSvc.setNextSequenceNoRaw(3, $scope.tdSeq.accountingBookId, $scope.tdSeq.selectedYear, m,
            function () {
                $scope.tdSeq.nextSequenceNo = m;
                $scope.isTdSequenceSaving = false;
            }, function (error) {
                $scope.isTdSequenceSaving = false;
            });
    }

    $scope.getSequenceNoPadded = function(number) {
        return (number % 100000).pad(5);
    }

    $scope.getAccountingBookIdPadded = function (number) {
        return (number % 1000).pad(3);
    }
    
    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.isSaving = false;

    $scope.onDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }

        if (!model.id) {
            accountingBookSvc.insert(model, success, error);
        } else {
            accountingBookSvc.update(model, success, error);
        }
    }

    $scope.onAddStampBtnClick = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.pictureWidth = 558;
            detailDialogPromise.$scope.pictureHeight = 206;
            detailDialogPromise.$scope.onUploadImage = function(data, success, error) {
              accountingBookSvc.uploadAccountingStamp($scope.model.id, data).$promise.then(function(result) {
                  success({'imageUrl': `restapi/accounting-books/${$scope.model.id}/accounting-stamp`});
              }, error);
            };
            detailDialogPromise.$scope.onImageSave = function (imageUrl) {
                $scope.accountingStampUrl = `restapi/accounting-books/${$scope.model.id}/accounting-stamp?${new Date().getTime()}`;
            }
            detailDialogPromise.show();
        });
    }
    
    $scope.onDeleteStampBtnClick = function() {

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_DELETE',
            message: 'TXT_TEXT_CONFIRM_DELETE_STAMP',
            buttons: [{
                text: 'TXT_BTN_NO'
            }, {
                text: 'TXT_BTN_YES',
                callback: function () {
                    accountingBookSvc.deleteAccountingStamp($scope.model.id).$promise.then(function() {
                        $scope.accountingStampUrl = `restapi/accounting-books/${$scope.model.id}/accounting-stamp?${new Date().getTime()}`;
                    });
                }
            }]
        });        
    }


    let detailDialogPromise = $modal({
        templateUrl: 'storage/pictures/pictures-detail.html',
        show: false,
        scope: $scope
    });

    let bankSelectionDialogPromise = $modal({
        templateUrl: 'finance/accounting-books/bank-selection-dialog.html',
        show: false,
        scope: $scope.$new()
    });

    let bankAccountSelectionDialogPromise = $modal({
        templateUrl: 'finance/accounting-books/bank-account-selection-dialog.html',
        show: false,
        scope: $scope.$new()
    });

}]);
